import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import PurchaseOrdersTable from "@/components/purchase-orders/purchase-orders-table";

const searchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/purchase-orders/")({
  validateSearch: searchSchema,
  component: PurchaseOrdersPage,
});

function PurchaseOrdersPage() {
  const searchParams = Route.useSearch();

  return (
    <RouteGuardPermissions
      permissions={[{ module: "purchase_orders", actions: ["read"] }]}
    >
      <div className="space-y-4">
        <PurchaseOrdersTable
          currentPage={searchParams.page}
          basePath="/purchase-orders"
          searchParams={searchParams}
        />
      </div>
    </RouteGuardPermissions>
  );
}
